<template>
  <div>
    <NavBar :admin="true" :items="items" />
		<v-main>
			<v-container>
        <v-progress-linear indeterminate color="primary" v-if="loading"></v-progress-linear>
        <template v-else>
          <ICDForm :icd="icd" />
        </template>
			</v-container>
		</v-main>
  </div>
</template>

<script>
import NavBar from "@/components/authentication/NavBar.vue";
import ICDForm from "@/components/icd/ICDForm.vue";

export default {
  name: "NewICD",
  components: {
    NavBar,
    ICDForm
  },
  data: () => ({
    loading: false,
    icd: {
      code: "",
      icd_chapter_id: null,
      information: {
        pt: {
          title: null,
          description: null
        },
        en: {
          title: null,
          description: null
        }
      }
    }
  }),
  computed: {
		items() {
			return [
				{
					text: this.$gettext("Dashboard"),
					disabled: false,
					link: true,
					to: "/admin/dashboard"
				},
				{
					text: "ICD-11",
					disabled: false,
          link: true,
          to: "/admin/dashboard/icd"
        },
        {
					text: this.$gettext("New"),
					disabled: true,
					link: true
				}
			];
		}
  }
}
</script>